import { EventDay } from '@/types/EventDay'
import { Moment } from 'moment-timezone'
import moment from 'moment/moment'
import { CalendarEventType, EventCalendar } from '@/types/Calendar'

export function dataEventDays(eventDays: EventDay[], datesClosingDays: Moment[]): EventCalendar[] {
    return eventDays
        .filter(
            (eventDay: EventDay): boolean =>
                !datesClosingDays.find((date: Moment) => date.isSame(moment(eventDay.date, 'DD-MM-YYYY')))
        )
        .map((eventDay: EventDay) => {
            const start: string = moment(eventDay.startHour, 'HH:mm:ss').format('HH:mm')
            const end: string = moment(eventDay.endHour, 'HH:mm:ss').format('HH:mm')

            return {
                title: `${start} - ${end} - ${eventDay.title}`,
                start: moment(
                    moment(eventDay.date, 'DD-MM-YYYY').format('YYYY-MM-DD') + ' ' + start,
                    'YYYY-MM-DD HH:mm'
                ).toDate(),
                end: moment(
                    moment(eventDay.date, 'DD-MM-YYYY').format('YYYY-MM-DD') + ' ' + end,
                    'YYYY-MM-DD HH:mm'
                ).toDate(),
                number: eventDay.reservation ? 'R' : '',
                type: CalendarEventType.EVENT,
                slots: eventDay
            }
        })
}
